import { Component, OnInit, Inject, ViewChild, ElementRef } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog, MatTableDataSource, MatSnackBar } from '@angular/material';
import { CreateEjeComponent } from '../../create-eje/create-eje.component';
import { Handle } from 'src/app/handle';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { GatewayService } from 'src/app/gateway.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ConfirmacionComponent } from 'src/app/home/confirmacion/confirmacion.component';
import { LocalSaveService } from 'src/app/services/local-save-service.service';
import { Md5 } from 'ts-md5/dist/md5';
import { Console } from 'console';
import { ComponentTabController } from 'src/app/tab-controller';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-dlg-citaprogram',
  templateUrl: './dlg-citaprogram.component.html',
  styleUrls: ['./dlg-citaprogram.component.scss']
})
export class DlgCitaprogramComponent implements OnInit {
  private destroy$ = new Subject<void>();
  historialColumns: string[] = [
    'fecha_ant',
    'am_pm_ant',
    'tecnico_ant',
    'locacion_ant',
    'sep',
    'fecha',
    'am_pm',
    'tecnico',
    'locacion',
    'usuario',
    'comentario',
    'fechainsert'
  ];

  provincias = [];
  distritos = [];
  corregimientos = [];

  // ViewChild buscadores
  @ViewChild('buscarProvincia') buscarProvincia: ElementRef;
  @ViewChild('buscarDistrito') buscarDistrito: ElementRef;
  @ViewChild('buscarCorregimiento') buscarCorregimiento: ElementRef;

  // Listas filtradas
  provinciasFiltradas: any[] = [];
  distritosFiltrados: any[] = [];
  corregimientosFiltrados: any[] = [];

  buscandoProvincia = false;
  buscandoDistrito = false;
  buscandoCorregimiento = false;

  // buscador
  @ViewChild('buscarTecnico') buscarTecnico: ElementRef;
  tecnicosFiltrados: any[] = [];
  buscando = false;

  minDate = new Date();
  grupoVal = new FormGroup({
    FECHAVISITA: new FormControl('', Validators.compose([
      Validators.required
    ])),
    TIEMPO: new FormControl('', Validators.compose([
      Validators.required
    ])),
    PROVINCIA: new FormControl('', Validators.compose([
      Validators.required
    ])),
    DISTRITO: new FormControl('', Validators.compose([
      Validators.required
    ])),
    CORREGIMIENTO: new FormControl('', Validators.compose([
      Validators.required
    ])),
    TECNICO: new FormControl(''),
    // [RF-08] Hora puntual: checkbox que habilita el campo de hora.
    // Ver: context/asignaciones/ADR-003-RF08-a-RF10-hora-puntual.md
    HORA_PUNTUAL_ACTIVA: new FormControl(false),
    HORA_PUNTUAL: new FormControl({ value: '', disabled: true }),
  });
  fechavisita: any;
  tecnico_ant: any;
  idprovincia_ant: any;
  iddistrito_ant: any;
  idcorregimiento_ant: any;
  tiempos = [
    {
      name: 'AM'
    },
    {
      name: 'PM'
    }
  ];
  tecnicos = [];
  historial: any[] = [];
  mostrarTecnico = false;

  constructor(
    private localSave: LocalSaveService,
    private spinner: NgxSpinnerService,
    private snackbar: MatSnackBar,
    private gateway: GatewayService,
    private dialog: MatDialog,
    private dialogRef: MatDialogRef<DlgCitaprogramComponent>, public Handle: Handle,
    public tabController: ComponentTabController,
    @Inject(MAT_DIALOG_DATA) public data: any) { }
  operacion = 'createagente';

  async ngOnInit() {
    // La seccion "Tecnico asignado" se muestra SOLO si:
    //   - El usuario tiene CITAS_ASIGNAR_TECNICO.permiso_editar = 1 (modulo dedicado), o
    //   - El usuario es esSuperAdmin (acceso total al sistema).
    // CITAS_PROGRAMADAS.permiso_editar habilita editar fecha/hora/ubicacion, pero NO
    // la asignacion de tecnico, que ahora es un sub-permiso aparte gestionado desde la
    // pantalla de Roles (modulo "Citas - Asignar Tecnico").
    const usr = this.localSave.get('usuarioPGV');
    const permisos = usr.permisos || [];
    const permAsignarTec = permisos.find(p => p.modulo === 'CITAS_ASIGNAR_TECNICO');
    const puedeAsignarTec = permAsignarTec ? permAsignarTec.permiso_editar === 1 : false;
    const esSuperAdmin = usr.esSuperAdmin;
    this.mostrarTecnico = esSuperAdmin || puedeAsignarTec;

    this.getProvincias();
    this.getHistorial();

    this.grupoVal.controls.TECNICO.valueChanges.pipe(takeUntil(this.destroy$)).subscribe(() => {
      if (!this.buscando) {
        this.ordenarTecnicosSeleccionadoPrimero();
      }
    });

    this.grupoVal.controls.PROVINCIA.valueChanges.pipe(takeUntil(this.destroy$)).subscribe(() => {
      if (!this.buscandoProvincia) {
        this.ordenarProvinciaSeleccionadaPrimero();
      }
    });

    this.grupoVal.controls.DISTRITO.valueChanges.pipe(takeUntil(this.destroy$)).subscribe(() => {
      if (!this.buscandoDistrito) {
        this.ordenarDistritoSeleccionadoPrimero();
      }
    });

    this.grupoVal.controls.CORREGIMIENTO.valueChanges.pipe(takeUntil(this.destroy$)).subscribe(() => {
      if (!this.buscandoCorregimiento) {
        this.ordenarCorregimientoSeleccionadoPrimero();
      }
    });

    // [RF-08] Listener: al marcar/desmarcar el checkbox de hora puntual,
    // habilita/deshabilita el campo HORA_PUNTUAL y ajusta validadores.
    this.grupoVal.controls.HORA_PUNTUAL_ACTIVA.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe((activa: boolean) => {
        const ctrl = this.grupoVal.controls.HORA_PUNTUAL;
        if (activa) {
          ctrl.enable();
          ctrl.setValidators([
            Validators.required,
            Validators.pattern(/^([01]\d|2[0-3]):[0-5]\d$/),
          ]);
        } else {
          ctrl.disable();
          ctrl.clearValidators();
          ctrl.setValue('');
        }
        ctrl.updateValueAndValidity();
      });

    if (this.data.operacion == 'Editar') {
      this.operacion = 'editagente';

      const partesDeLaFecha = this.data.agente.fecha_visita.toString().split('-');
      const anio = parseInt(partesDeLaFecha[0]);
      const mes = parseInt(partesDeLaFecha[1]) - 1; // ¡Importante! Los meses en JavaScript van de 0 a 11
      const dia = parseInt(partesDeLaFecha[2]);
      this.fechavisita = new Date(anio, mes, dia);
      // console.log('data:', this.data);
      this.grupoVal.controls.FECHAVISITA.setValue(this.fechavisita);
      this.grupoVal.controls.TIEMPO.setValue(this.data.agente.am_pm);
      this.grupoVal.controls.PROVINCIA.setValue(this.data.agente.idprovincia);
      this.ordenarProvinciaSeleccionadaPrimero();
      this.idprovincia_ant = this.data.agente.idprovincia;
      this.iddistrito_ant = this.data.agente.iddistrito;
      this.idcorregimiento_ant = this.data.agente.idcorregimiento;

      // [RF-08] Precargar hora puntual si la cita ya tiene una registrada.
      // El valor llega como "HH:MM" (VARCHAR) o "HH:MM:SS" (TIME); normalizamos a HH:MM.
      // IMPORTANTE: habilitar el control ANTES de setValue para evitar que el listener
      // del checkbox lo pise al reaccionar con clearValidators().
      if (this.data.agente.hora_puntual) {
        const horaValue = String(this.data.agente.hora_puntual).substring(0, 5);
        this.grupoVal.controls.HORA_PUNTUAL.enable();
        this.grupoVal.controls.HORA_PUNTUAL.setValue(horaValue);
        // emitEvent: false evita re-disparar el listener y sobrescribir el valor.
        this.grupoVal.controls.HORA_PUNTUAL_ACTIVA.setValue(true, { emitEvent: false });
      }

      this.gateway.save('gettecnicosxcontrata', { IDDISTRIBUIDOR: this.data.agente.idcontrata, IDCONTRATA2: this.localSave.get('usuarioPGV').IDCONTRATA2, IDAREA: this.data.IDAREA }).then((result) => {
        // this.spinner.hide();
        let resp: any = result;
        if (resp.response == 1) {
          this.tecnicos = resp.rows;
          this.ordenarTecnicosSeleccionadoPrimero();
          this.tecnicosFiltrados = this.tecnicos.slice();

        }
        this.grupoVal.controls.TECNICO.setValue(this.data.agente.idtecnico);
        this.ordenarTecnicosSeleccionadoPrimero();
        this.tecnico_ant = this.data.agente.idtecnico || null;
      }).catch(function (e) { });

      this.gateway.get('getdistritosxprovincia', {
        id_padre: this.data.agente.idprovincia
      }).then((result) => {
        let aux: any = result;
        this.distritos = aux.rows;
        this.distritosFiltrados = this.distritos.slice();
        this.grupoVal.controls.DISTRITO.setValue(this.data.agente.iddistrito);
        this.ordenarDistritoSeleccionadoPrimero();
      });

      this.gateway.get('getcorregimientosxdistrito', {
        id_padre: this.data.agente.iddistrito
      }).then((result) => {
        let aux: any = result;
        this.corregimientos = aux.rows;
        this.corregimientosFiltrados = this.corregimientos.slice();
        this.grupoVal.controls.CORREGIMIENTO.setValue(this.data.agente.idcorregimiento);
        this.ordenarCorregimientoSeleccionadoPrimero();
      });

    }

  }

  getHistorial() {
    this.gateway.get('histcitaprogramada', {
      IDCITA: this.data.agente.id
    }).then((result) => {
      let aux: any = result;
      this.historial = aux.rows || [];
    });
  }

  getProvincias() {
    this.gateway.get('getprovincias', {}).then((result) => {
      let aux: any = result;
      this.provincias = aux.rows;
      this.provinciasFiltradas = this.provincias.slice();
      this.ordenarProvinciaSeleccionadaPrimero();
    });
  }

  getDistritos(event: any) {
    const element = event.value;
    if (element) {
      this.grupoVal.controls.DISTRITO.setValue('');
      this.grupoVal.controls.CORREGIMIENTO.setValue('');
      this.corregimientos = [];
      this.corregimientosFiltrados = [];

      this.gateway.get('getdistritosxprovincia', {
        id_padre: element
      }).then((result) => {
        let aux: any = result;
        this.distritos = aux.rows;
        this.distritosFiltrados = this.distritos.slice();
        this.ordenarDistritoSeleccionadoPrimero();
      });
    }
  }

  getCorregimientos(event: any) {
    const element = event.value;
    if (element) {
      this.grupoVal.controls.CORREGIMIENTO.setValue('');

      this.gateway.get('getcorregimientosxdistrito', {
        id_padre: element
      }).then((result) => {
        let aux: any = result;
        this.corregimientos = aux.rows;
        this.corregimientosFiltrados = this.corregimientos.slice();
        this.ordenarCorregimientoSeleccionadoPrimero();
      });
    }
  }

  filtrarProvincias(valor: string) {
    const filtro = valor.toLowerCase().trim();
    this.buscandoProvincia = filtro.length > 0;

    let filtradas = this.provincias.filter(p =>
      p.nombre.toLowerCase().includes(filtro)
    );

    if (!this.buscandoProvincia) {
      const seleccionadoId = this.grupoVal.controls.PROVINCIA.value;
      if (seleccionadoId) {
        const sel = filtradas.find(p => p.idprovincia === seleccionadoId);
        filtradas = filtradas.filter(p => p.idprovincia !== seleccionadoId);
        if (sel) filtradas.unshift(sel);
      }
    }

    this.provinciasFiltradas = filtradas;
  }

  filtrarDistritos(valor: string) {
    const filtro = valor.toLowerCase().trim();
    this.buscandoDistrito = filtro.length > 0;

    let filtrados = this.distritos.filter(d =>
      d.nombre.toLowerCase().includes(filtro)
    );

    if (!this.buscandoDistrito) {
      const seleccionadoId = this.grupoVal.controls.DISTRITO.value;
      if (seleccionadoId) {
        const sel = filtrados.find(d => d.iddistrito === seleccionadoId);
        filtrados = filtrados.filter(d => d.iddistrito !== seleccionadoId);
        if (sel) filtrados.unshift(sel);
      }
    }

    this.distritosFiltrados = filtrados;
  }

  filtrarCorregimientos(valor: string) {
    const filtro = valor.toLowerCase().trim();
    this.buscandoCorregimiento = filtro.length > 0;

    let filtrados = this.corregimientos.filter(c =>
      c.nombre.toLowerCase().includes(filtro)
    );

    if (!this.buscandoCorregimiento) {
      const seleccionadoId = this.grupoVal.controls.CORREGIMIENTO.value;
      if (seleccionadoId) {
        const sel = filtrados.find(c => c.idcorregimiento === seleccionadoId);
        filtrados = filtrados.filter(c => c.idcorregimiento !== seleccionadoId);
        if (sel) filtrados.unshift(sel);
      }
    }

    this.corregimientosFiltrados = filtrados;
  }

  onOpenedProvincia(opened: boolean) {
    if (opened) setTimeout(() => this.buscarProvincia.nativeElement.focus(), 0);
  }

  onOpenedDistrito(opened: boolean) {
    if (opened) setTimeout(() => this.buscarDistrito.nativeElement.focus(), 0);
  }

  onOpenedCorregimiento(opened: boolean) {
    if (opened) setTimeout(() => this.buscarCorregimiento.nativeElement.focus(), 0);
  }

  ordenarProvinciaSeleccionadaPrimero() {
    const seleccionadoId = this.grupoVal.controls.PROVINCIA.value;

    if (!seleccionadoId) {
      this.provinciasFiltradas = this.provincias.slice();
      return;
    }

    const seleccionado = this.provincias.find(
      p => p.idprovincia === seleccionadoId
    );

    const resto = this.provincias.filter(
      p => p.idprovincia !== seleccionadoId
    );

    this.provinciasFiltradas = seleccionado
      ? [seleccionado, ...resto]
      : resto.slice();
  }

  ordenarDistritoSeleccionadoPrimero() {
    const seleccionadoId = this.grupoVal.controls.DISTRITO.value;

    if (!seleccionadoId) {
      this.distritosFiltrados = this.distritos.slice();
      return;
    }

    const seleccionado = this.distritos.find(
      d => d.iddistrito === seleccionadoId
    );

    const resto = this.distritos.filter(
      d => d.iddistrito !== seleccionadoId
    );

    this.distritosFiltrados = seleccionado
      ? [seleccionado, ...resto]
      : resto.slice();
  }

  ordenarCorregimientoSeleccionadoPrimero() {
    const seleccionadoId = this.grupoVal.controls.CORREGIMIENTO.value;

    if (!seleccionadoId) {
      this.corregimientosFiltrados = this.corregimientos.slice();
      return;
    }

    const seleccionado = this.corregimientos.find(
      c => c.idcorregimiento === seleccionadoId
    );

    const resto = this.corregimientos.filter(
      c => c.idcorregimiento !== seleccionadoId
    );

    this.corregimientosFiltrados = seleccionado
      ? [seleccionado, ...resto]
      : resto.slice();
  }

  /**
   * Funciones para el mat-select tecnico
   * - ordenarTecnicosSeleccionadoPrimero
   * - filtrarTecnicos
   * - onOpenedChange
   * 
   */

  ordenarTecnicosSeleccionadoPrimero() {
    const seleccionado = this.grupoVal.controls.TECNICO.value;

    if (!seleccionado) {
      this.tecnicosFiltrados = this.tecnicos.slice();
      return;
    }

    const seleccionadoObj = this.tecnicos.find(t => t.idagente === seleccionado);
    const resto = this.tecnicos.filter(t => t.idagente !== seleccionado);

    this.tecnicosFiltrados = seleccionadoObj
      ? [seleccionadoObj, ...resto]
      : resto.slice();
  }

  filtrarTecnicos(valor: string) {
    const filtro = valor.toLowerCase().trim();
    this.buscando = filtro.length > 0;

    let filtrados = this.tecnicos.filter(t =>
      t.nombre.toLowerCase().includes(filtro)
    );

    // SOLO mover seleccionado si NO se está buscando
    if (!this.buscando) {
      const seleccionado = this.grupoVal.controls.TECNICO.value;
      if (seleccionado) {
        const sel = filtrados.find(t => t.idagente === seleccionado);
        filtrados = filtrados.filter(t => t.idagente !== seleccionado);
        if (sel) {
          filtrados.unshift(sel);
        }
      }
    }

    this.tecnicosFiltrados = filtrados;
  }

  onOpenedChange(opened: boolean) {
    if (opened) {
      setTimeout(() => {
        if (this.buscarTecnico) {
          this.buscarTecnico.nativeElement.focus();
        }
      }, 0);
    }
  }

  crear() {

    const dialogRef = this.dialog.open(ConfirmacionComponent, {
      disableClose: true,
      width: '450px',
      data: { sms: 'guardar las modificaciones hechas en la cita', addcomment: true }
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result.resp) {
        const usr = this.localSave.get('usuarioPGV');
        let datos = {
          IDCITA: this.data.agente.id,
          IDCONTRATA: usr.IDU,
          FECHAVISITAANT: this.fechavisita,
          IDTECNICOANT: this.tecnico_ant,
          IDPROVINCIAANT: this.idprovincia_ant,
          IDDISTRITOANT: this.iddistrito_ant,
          IDCORREGIMIENTOANT: this.idcorregimiento_ant,
          TIEMPOANT: this.data.agente.am_pm,
          FECHAVISITA: this.grupoVal.controls.FECHAVISITA.value,
          TIEMPO: this.grupoVal.controls.TIEMPO.value,
          // [RF-08] Cuando hora puntual esta activa, el IDTECNICO del body es ignorado por el
          // backend (auto-pick por pool/job). Enviamos null explicito para alinear el payload
          // con el contrato del backend y evitar que un merge futuro reintroduzca el bug en
          // el que el tecnico precargado quedaba asignado al activar hora puntual.
          IDTECNICO: this.grupoVal.controls.HORA_PUNTUAL_ACTIVA.value
            ? null
            : this.grupoVal.controls.TECNICO.value,
          IDPROVINCIA: this.grupoVal.controls.PROVINCIA.value,
          IDDISTRITO: this.grupoVal.controls.DISTRITO.value,
          IDCORREGIMIENTO: this.grupoVal.controls.CORREGIMIENTO.value,
          // [RF-08] Hora puntual: null si el checkbox esta desmarcado (limpia campo en BD)
          HORA_PUNTUAL: this.grupoVal.controls.HORA_PUNTUAL_ACTIVA.value
            ? this.grupoVal.controls.HORA_PUNTUAL.value
            : null,
          COMENTARIO: result.comentario,
          IDUSUARIO: usr.IDU,
          NOMBRE_USUARIO: this.localSave.get('userLoggedIn') || null,
          CORREO_USUARIO: this.localSave.get('email') || null,
        }
        this.gateway.save('updatecitaprogramada', datos).then((result: any) => {
          this.spinner.hide();
          if (result.response == 1) {
            this.snackbar.open('Datos almacenados con éxito.', 'Cerrar', { duration: 3000, });
          } else {
            this.snackbar.open(result.msgerror, 'Cerrar', { duration: 10000, });
          }
          this.dialogRef.close(true);
        }).catch(function (e) {
          //console.log('eeee: ',e);
        });
      }
    });
  }

  onNoClick() {
    for (const controlName in this.grupoVal.controls) {
      const control = this.grupoVal.get(controlName);
      if (control && control.invalid) {
      }
    }
    this.dialogRef.close(false);
  }

  tabChanged(event: any) {
    this.getHistorial();
  }


  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
